/**
 * Scroll the first invalid field into view after a failed form validation.
 *
 * Looks for the first element (in DOM order) that carries the shared error
 * markers used across the app (`input.error`, `.field-error`, …) inside `root`
 * (defaults to the whole document). Runs on the next tick so the error markup
 * React just rendered is already in the DOM.
 */
const ERROR_SELECTOR =
  "input.error, select.error, textarea.error, .error, .field-error";

export const scrollToFirstError = (root) => {
  if (typeof document === "undefined") return;
  setTimeout(() => {
    const scope = root && typeof root.querySelector === "function" ? root : document;
    const el = scope.querySelector(ERROR_SELECTOR);
    if (!el) return;
    const group = el.closest(".form-group") || el;
    group.scrollIntoView({ behavior: "smooth", block: "center" });
    const field =
      group.querySelector("input.error, select.error, textarea.error") ||
      (el.matches("input, select, textarea") ? el : null);
    if (field && typeof field.focus === "function") {
      field.focus({ preventScroll: true });
    }
  }, 0);
};
